/**
 * Format cents as a dollar string (e.g. 5000 → "$50.00").
 * @param {number|null} cents
 * @returns {string}
 */
export function formatCents(cents) {
    if (cents == null) return '-';
    return `$${(cents / 100).toFixed(2)}`;
}

/**
 * Format an ISO date string as a short localized date (e.g. "Mar 28, 2026").
 * @param {string} dateStr
 * @returns {string}
 */
export function formatMediumDate(dateStr) {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Trigger a browser download of a markdown string as a .md file.
 * @param {string} filename
 * @param {string} content
 */
export function downloadMarkdown(filename, content) {
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
